// Angular
import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/Services/utils.service';

export interface ISearchResult {
	icon: string;
	img: string;
	title: string;
	text: string;
	url: string;
}

@Component({
	selector: 'kt-search-result',
	templateUrl: './search-result.component.html',
	styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent {
	// Public properties
	@Input() data: ISearchResult[];
	@Input() noRecordText: string;
	permissions = localStorage.getItem('permissions');

	constructor( private util : UtilsService){ }
	redirect(item){
		if(this.checkPermission(item.permission)){
			this.util.redirect(item.url);
		}else{
			this.util.alertNotificationMessage('You are not authorised to visit : '+ item.name)
		}
	  }
	  checkPermission(value){
		if(this.permissions.includes(value)){
		  return true;
		}else{
		  return false;
		}
	  }
}
